import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Overview = ({ textData }) => {
  return (
    <h5
      className={styles.text}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(textData['text2']),
      }}
    ></h5>
  );
};

export default Overview;
